/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CartNav_user$ref = any;
export type CartNav_user = {
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $refType": CartNav_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "CartNav_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'a56ba97f4561a08ba9b65787eb607cf6';
export default node;
